module.exports = __webpack_public_path__ + "static/logistics-tracking-32dc17b57236d4fdfd8f2fe7a8828731.png";